module.exports = __webpack_public_path__ + "static/img/gtgl@2x.b4a8c93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/gtgl@2x.png
// module id = mIz+
// module chunks = 1